import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcTable from '@/components/Table.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import BcMask from '@/components/Mask.vue';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcHisInfo from '@/components/HisInfo.vue';
class HisForm extends CBcDialogForm {
    constructor(form) {
        super();
        const that = this;
        if (form) {
            Object.keys(form).forEach((k) => {
                that[k] = form[k];
            });
        }
    }
}
let HospHis = class HospHis extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.maskValue = {
            isShow: false,
        };
        this.dataSource = {
            headers: [
                { text: '医院', value: 'hospital' },
                { text: '状态', value: 'state' },
                { text: '信息类型', value: 'type' },
                { text: '服务地址', value: 'address' },
                { text: '配置情况', value: 'detail', sortable: false },
                { text: '操作', value: 'action', sortable: false, width: 120, align: 'center' },
            ],
            desserts: [],
            isDetail: true,
        };
        this.pagination = {
            current: 10,
            countSum: 10,
            limit: 10,
            items: 10,
            curPre: 1
        };
        const that = this;
        that.dialog = new CBcDialog(new HisForm());
    }
    mounted() {
        const that = this;
        that.getHisList();
    }
    async save() {
        const that = this;
        const value = that.dialog.form;
        that.maskValue.isShow = true;
        const isCreate = that.dialog.isCreateType;
        const iTitle = isCreate ? '新增医院HIS信息' : '修改医院HIS信息';
        that.axios.request({
            method: isCreate ? 'post' : 'put',
            url: isCreate ? '/api/hospital/his' : `/api/hospital/his/${value.id}`,
            data: { ...value }
        }).then(() => {
            that.maskValue.isShow = false;
            that.snackbar.success(iTitle + '成功！');
            that.getHisList();
        }).catch((e) => {
            that.snackbar.error(iTitle + '失败,' + (e && (e.info || e.result || e.error)));
            that.maskValue.isShow = false;
        });
    }
    async getHisList(value = false) {
        const that = this;
        that.maskValue.isShow = true;
        let user;
        try {
            user = await that.axios.get('/api/hospital/his', { params: { limit: that.pagination.limit, page: that.pagination.curPre, withHospitalInfo: true } });
        }
        catch (e) {
            that.maskValue.isShow = false;
            return that.snackbar.error('获取信息失败！');
        }
        const dataValue = user.data.result;
        that.dataSource.desserts = [];
        if (dataValue.length) {
            dataValue.forEach((item, index) => {
                if (item.username !== 'admin')
                    that.dataSource.desserts.push({ ...item });
            });
        }
        that.pagination.items = Math.ceil(user.data.sum / user.data.limit) || 1;
        that.maskValue.isShow = false;
    }
    limitFun(value) {
        const that = this;
        that.pagination.limit = value;
        that.pagination.curPre = 1;
        that.getHisList();
    }
    pagePreFun(value) {
        const that = this;
        that.pagination.curPre = value;
        that.getHisList();
    }
    hisFormSave(error, msg) {
        const that = this;
        if (!error) {
            that.getHisList();
        }
    }
};
HospHis = __decorate([
    Component({
        name: 'HIS',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
            BcMask,
            BcHisInfo
        },
    })
], HospHis);
export default HospHis;
;
